import { useMutation, useQueryClient } from '@tanstack/react-query';
import { releaseSeatTwo } from '@/api/data-room-access.api';
import { dataRoomAccessKeys } from '@/hooks/data-room-access.queries';
import { toast } from '@/lib/toast';
import { TEAM_STRINGS } from '@/lib/constants/team-strings';

const COPY = TEAM_STRINGS.DATA_ROOM_SEATS;

/**
 * Empties seat 2 from Team Access (FR-139), confirmed in a dialog first. The
 * dialog stays open on failure and renders `mutation.error` inline; success
 * closes it, so success is a toast (mnr-standards "Write-action feedback").
 * A refusal refetches the view, since it usually means seat 2 changed.
 *
 * @param entityId - the startup entity
 */
export function useReleaseSeatTwo(entityId: string) {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (expectedHolderUserId: string) => releaseSeatTwo(entityId, expectedHolderUserId),
    onSuccess: (access) => {
      queryClient.setQueryData(dataRoomAccessKeys.forStartup(entityId), access);
      toast.success(COPY.RELEASED);
    },
    onError: () => {
      void queryClient.invalidateQueries({ queryKey: dataRoomAccessKeys.forStartup(entityId) });
    },
  });
}
